import type { Severity } from '@/types/ticket'
import { SEVERITIES, severityLabels } from '@/lib/sla'
import { railSelectClass } from './railSelect'

export function SeveritySelect({ value, onChange, disabled }: { value: Severity; onChange: (s: Severity) => void; disabled?: boolean }) {
  return (
    <select aria-label="Severity" disabled={disabled} value={value} onChange={e => onChange(e.target.value as Severity)} className={railSelectClass}>
      {SEVERITIES.map(s => <option key={s} value={s}>{severityLabels[s]}</option>)}
    </select>
  )
}
